import { EntityType } from '@frontend/common';
import { IdentificationClient } from '@frontend/identification/api';
import { Identification, UpdateIdentification } from '@frontend/identification/types';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';

export interface ApiKeyUpdateProps {
    apiKey: Identification;
    onSubmitSuccess?: (value: Identification) => void;
}

export const ApiKeyUpdate = (props: ApiKeyUpdateProps) => {
    return (
        <UpdateModal<Identification, UpdateIdentification>
            order={['key', 'secret', 'valid_timestamp']}
            object={props.apiKey}
            values={{ ...props.apiKey }}
            fieldProps={() => new Map([['valid_timestamp', { type: 'datetime' }]])}
            onSubmit={(value) => IdentificationClient.patchIdentification(props.apiKey.account_id, props.apiKey.id, value)}
            type={EntityType.IDENTIFICATION}
            label={
                <FormattedMessage
                    id='api-key.update.title'
                    defaultMessage='Update API key'
                />
            }
            onSubmitSuccess={props.onSubmitSuccess}
            successMessageOverwrite={
                <FormattedMessage
                    id='api-key.update.success'
                    defaultMessage='API key updated successfully'
                />
            }
        />
    );
};
